import { NAME } from './constants';

export const getFlight = state => state[NAME];
